import { Icon, IconProps } from '@jisr-hr/ds'

const DSIcon = (props: Omit<IconProps, 'whiteLabel'>): JSX.Element => (
  <Icon
    {...props}
    whiteLabel={import.meta.env.REACT_APP_WHITE_LABEL}
  />
)

export default DSIcon
